import { generateClient, GraphQLResult } from "aws-amplify/api";
import { Permission } from "db/definitions";
// @ts-ignore
import { listPermissions } from "graphql/queries";

export async function getPermissions(): Promise<Permission[]> {
	const permissions: Permission[] = [];
	let nextToken;
	while (nextToken !== null) {
		interface QueryResponse {
			listPermissions: {
				items: Permission[];
				nextToken: string | null;
			};
		}
		const client = generateClient({ authMode: "userPool" });
		const response = (await client.graphql({
			query: listPermissions,
			authMode: "userPool",
		})) as GraphQLResult<QueryResponse>;
		nextToken = response.data.listPermissions.nextToken;
		for (const permission of response.data.listPermissions.items) {
			permissions.push(permission);
		}
	}
	return permissions;
}
